import { render, staticRenderFns } from "./FullScreenCalendar.vue?vue&type=template&id=19ea0af3&scoped=true&"
import script from "./FullScreenCalendar.vue?vue&type=script&lang=ts&"
export * from "./FullScreenCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ea0af3",
  null
  
)

export default component.exports